if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomControls = this.querySelector('.product-media-modal__zoom-controls');
        this.zoomButtons = this.querySelectorAll('[data-product-media-zoom]');
        this.zoomScale = 1;
        this.zoomStep = 0.5;
        this.minZoomScale = 1;
        this.maxZoomScale = 3;
        this.zoomControls?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.zoomControls?.addEventListener('click', (event) => event.stopPropagation());
        this.zoomButtons.forEach((button) => button.addEventListener('click', this.onZoomButtonClick.bind(this)));
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.resetZoom();
        this.updateZoomControls(activeMedia);
      }

      onZoomButtonClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const activeMedia = this.querySelector('[data-media-id].active');
        const image = this.getActiveImage(activeMedia);
        if (!image) return;

        const direction = event.currentTarget.dataset.productMediaZoom;
        const nextScale =
          direction === 'in' ? this.zoomScale + this.zoomStep : this.zoomScale - this.zoomStep;
        this.zoomScale = Math.min(this.maxZoomScale, Math.max(this.minZoomScale, nextScale));
        this.applyZoom(image);
      }

      applyZoom(image) {
        image.style.width = `${this.zoomScale * 100}%`;
        image.style.maxWidth = 'none';
        image.style.cursor = this.zoomScale > this.minZoomScale ? 'zoom-out' : 'zoom-in';
        this.updateZoomControls(image.closest('[data-media-id]'));
      }

      resetZoom() {
        this.zoomScale = this.minZoomScale;
        this.querySelectorAll('.product-media-modal__content img').forEach((image) => {
          image.style.removeProperty('width');
          image.style.removeProperty('max-width');
          image.style.removeProperty('cursor');
        });
      }

      updateZoomControls(activeMedia) {
        const hasImage =
          Boolean(this.getActiveImage(activeMedia)) && !activeMedia?.querySelector?.('video, iframe, model-viewer');
        if (!this.zoomControls) return;

        this.zoomControls.hidden = !hasImage;
        this.zoomControls.setAttribute('aria-hidden', hasImage ? 'false' : 'true');

        this.zoomButtons.forEach((button) => {
          const direction = button.dataset.productMediaZoom;
          button.disabled =
            !hasImage ||
            (direction === 'out' && this.zoomScale <= this.minZoomScale) ||
            (direction === 'in' && this.zoomScale >= this.maxZoomScale);
        });
      }

      getActiveImage(activeMedia) {
        if (!activeMedia) return null;
        return activeMedia.matches?.('img') ? activeMedia : activeMedia.querySelector?.('img');
      }
    }
  );
}
